export const currencyCode = [
  {
    countryName: "United States",
    currency_code: "USD",
    currency_symbol: "$",
    currency_name: "US Dollar",
    timeZone: "Asia/usa",
    region: "USA",
    language: "en",
    taxName: "United States Sales Tax",
    taxCode: "USTAX",
    dialCode: "+1",
  },
  {
    countryName: "India",
    currency_code: "Rs",
    currency_symbol: "₹",
    currency_name: "Indian Rupee",
    timeZone: "Asia/Kolkata",
    region: "IN",
    language: "en",
    taxName: "Goods and Services Tax",
    taxCode: "GSTIN",
    dialCode: "+91",
  },
  {
    countryName: "United Arab Emirates",
    currency_code: "AED",
    currency_symbol: "د.إ",
    currency_name: "Emirati Dirham",
    timeZone: "Asia/Dubai",
    region: "AE",
    language: "ar",
    taxName: "Tax Registration Number",
    taxCode: "TRN",
    dialCode: "+971",
  },
  {
    countryName: "Kuwait",
    currency_code: "KWD",
    currency_symbol: "ك.د",
    currency_name: "Kuwaiti Dinar",
    timeZone: "Asia/Kuwait",
    region: "KW",
    language: "ar",
    taxName: "Kuwait Sales Tax",
    taxCode: "KWTAX",
    dialCode: "+965",
  },
  {
    countryName: "Qatar",
    currency_code: "QAR",
    currency_symbol: "ر.ق.",
    currency_name: "Qatari Riyal",
    timeZone: "Asia/Qatar",
    region: "QA",
    language: "ar",
    taxName: "Tax Identification Number",
    taxCode: "TIN",
    dialCode: "+974",
  },
  {
    countryName: "Oman",
    currency_code: "OMR",
    currency_symbol: "ر.ع.",
    currency_name: "Omani Rial",
    timeZone: "Asia/Muscat",
    region: "OM",
    language: "ar",
    taxName: "VAT Registration Number ",
    taxCode: "VATIN",
    dialCode: "+968",
  },
];
